import { Link } from 'react-router-dom';

const stats = [
  { value: '500,000+', label: '累计用户' },
  { value: '98.6%', label: '好评率' },
  { value: '300+', label: '城市覆盖' },
  { value: '7×24', label: '专属服务' },
];

export default function CtaSection() {
  return (
    <section className="relative py-14 md:py-20 bg-background-900 overflow-hidden">
      <div className="absolute inset-0 opacity-8">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-1.5">
                {s.value}
              </p>
              <p className="text-xs md:text-sm text-background-400">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            准备好探索
            <span className="text-primary-400">性巴克</span>
            了吗？
          </h2>
          <p className="text-background-400 text-sm md:text-base mb-8 md:mb-10 leading-relaxed">
            立即加入性巴克的大家庭，开启属于你的独特生活体验。现在购买还可享受新用户专属优惠。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/categories"
              className="w-full sm:w-auto px-8 py-3 md:px-10 md:py-3.5 bg-primary-500 text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              立即选购
            </Link>
            <Link
              to="/articles"
              className="w-full sm:w-auto px-8 py-3 md:px-10 md:py-3.5 border border-background-50/25 text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-background-50/10 transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}